import React, { useEffect, useState } from 'react';
import { Button, InputNumber, Typography } from 'antd';
import {
  POS_HOLD_HELP, POS_HOLD_LABEL, POS_HOLD_MAX, POS_HOLD_MIN, POS_HOLD_TITLE, posHoldError,
} from 'utils/posHold';
import { StyledWrapper } from '../CateringSetupTime/styles';

function PosHoldEditor({
  value,
  onSave,
}) {
  const [draft, setDraft] = useState(value);
  const [error, setError] = useState(() => posHoldError(value));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft(value);
    setError(posHoldError(value));
  }, [value]);

  const handleSave = () => {
    const validationError = posHoldError(draft);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError(null);
    setSaving(true);
    Promise.resolve(onSave(Number(draft)))
      .catch((saveError) => {
        setError(saveError?.message || 'Could not save the POS hold.');
      })
      .finally(() => setSaving(false));
  };

  return (
    <StyledWrapper>
      <div className="box" data-testid="pos-hold">
        <div className="box-title">{POS_HOLD_TITLE}</div>
        <label className="catering-setup-label" htmlFor="pos-hold-minutes">
          {POS_HOLD_LABEL}
        </label>
        <div className="catering-setup-row">
          <InputNumber
            id="pos-hold-minutes"
            className="catering-setup-input"
            min={POS_HOLD_MIN}
            max={POS_HOLD_MAX}
            step={1}
            precision={0}
            inputMode="numeric"
            value={draft ?? null}
            onChange={(next) => {
              setDraft(next);
              setError(posHoldError(next));
            }}
          />
          <Button
            type="primary"
            onClick={handleSave}
            loading={saving}
            disabled={Boolean(error) || saving}
          >
            Save
          </Button>
        </div>
        {error && (
          <Typography.Text className="catering-setup-error" type="danger" role="alert">
            {error}
          </Typography.Text>
        )}
        <span className="catering-setup-help">{POS_HOLD_HELP}</span>
      </div>
    </StyledWrapper>
  );
}

export default PosHoldEditor;
